import React, { useState, useEffect, useMemo } from 'react';
import { Button, Grid, useMediaQuery } from '@mui/material';
import CalendarIconButton from "@/app/ui/RaceCalendar/components/RaceCalendar/calendarButton";
import HorseFormGuideIcon from './Icon/horseFormGuide';
import "@/app/style/raceHeader.scss";
import RacingCalendar from './RaceCalendar/components/RaceCalendar/racingCalendar';
import { theme, adobeData, generateUrl, getAdditionalInfoForFixture, getSearchParams, generateAdobeDataRaceNo, getMeetingCountryAbbr } from "@/app/utils/Common";
import dayJS, { formattedDate, dateFormat, toDate } from "@/app/utils/DayJS";
import { LANGTYPE_EN, LangCode, useLanguage } from '@/app/utils/LanguageContext';
import { useMyContext } from '@/app/utils/MyContext';
import { getBusinessDate, getFixtureList, getHomeBasicInfo } from '@/app/utils/request/requestList';
import { Dayjs } from 'dayjs';
import { MenuTab } from '@/app/utils/class/common/base';
import { textSize } from "@/app/utils/MixinSize";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { menuTabSet } from '@/app/utils/constant/menuTabSet';
    
const NextDayRaceBtn = (props: {langCode: LangCode, isMobile?: boolean, nextDayRace?: Date, text?: string}) => {
    const { state: myContextState } = useMyContext();
    const onClickNextdayraceHandler = (e: any, nextday?: Date) => {
        e.stopPropagation();
        if (nextday) {
            window.location.href = generateUrl(`/${encodeURIComponent(new MenuTab(menuTabSet.RACE_SUMMARY).valueOf())}`, { 'RaceDate': formattedDate(nextday, "YYYYMMDD") });
        }
    }

    return props.nextDayRace && 
    <Button className={`nextdayraceBtn${props.isMobile?" mobile": ""}`} startIcon={<img src={`${myContextState.assetPrefix}/double_arrow.svg`} />} onClick={(e:any) => onClickNextdayraceHandler(e, props.nextDayRace)}>
        {props.text}
    </Button>
}

interface PropType {
    meetings?: IMeeting[];
}

const RacingHeader = (props: PropType) => {
    const { state: myContextState, dispatch: myContextDispatch } = useMyContext();
    const { state: lang } = useLanguage();
    const { t } = lang;
    const [showCalendar, setCalender] = useState(true);
    const [isShowSelect, setIsShowSelect] = useState(false);
    const [displayMonth, setDisplayMonth] = useState<Dayjs>();
    const [fixtureData, setFixtureData] = useState<{ fixtureList: IFixture[]; fixtureConfig: any }>();
    const [businessDate, setBusinessDate] = useState<Dayjs>();
    const [isCurrentMonthFin, setIsCurrentMonthFin] = useState<boolean>(false);

    const { RaceDate: urlDate } = getSearchParams(new URLSearchParams(window.location.search));

    const serverDateFormat = lang.langType === LANGTYPE_EN ? "M/D/YYYY" : "D/M/YYYY";
    const isMobile = useMediaQuery(theme.breakpoints.down('lg'));
    const [isDim, setisDim] = useState(false);

    const handleShowTab = (event: { target: any; }) => {
        setIsShowSelect(!isShowSelect);
    };

    const handleOutSideclick = (event:any) => {
        const targetDiv = document.querySelector('#formGuideItem');
        const targetDiv2 = document.querySelector('.formGuideListNew');
        const rect = targetDiv?.getBoundingClientRect()|| {} as any;
        const rect2 = targetDiv2?.getBoundingClientRect() || {} as any;
            
        const isInside =
        event?.clientX >= rect?.left &&
        event?.clientX <= rect?.right &&
        event?.clientY >= rect?.top &&
        event?.clientY <= rect?.bottom;

        const isInside2 =
        event?.clientX >= rect2?.left &&
        event?.clientX <= rect2?.right &&
        event?.clientY >= rect2?.top &&
        event?.clientY <= rect2?.bottom;

        if (!isInside && !isInside2) {
            setIsShowSelect(false);
        }
    }
    useEffect(() => {
        console.log('formGuides----', myContextState?.formGuides)
       
        if(isMobile) document.addEventListener('click', handleOutSideclick);
        return () => {
            if(isMobile) document.removeEventListener('click', handleOutSideclick);
        }
    }, []);
    useEffect(() => {
        const ifneedDim = !checkFormGuidesData();
        setisDim(ifneedDim)
    }, [myContextState?.formGuides])

    const setInitialMonthDisplay = (fixtureList: IFixture[], businessDate: Dayjs) => {
        let targetDate = dayJS(urlDate, "YYYYMMDD").isValid() ? dayJS(urlDate, "YYYYMMDD") : businessDate; // hightlight date in url 
        
        if(!fixtureList.some((r: any) => dayJS(r.date_HK?.value, serverDateFormat).isSame(businessDate, 'month') && dayJS(r.date_HK?.value, serverDateFormat).isSameOrAfter(businessDate))){
            setIsCurrentMonthFin(true);
        }

        if (!fixtureList.some((r: any) => dayJS(r.date_HK?.value, serverDateFormat).isSame(targetDate, 'month') && dayJS(r.date_HK?.value, serverDateFormat).isSameOrAfter(targetDate))) {
            // current month does not have upcoming meeting
            if (fixtureList.some((r: any) => dayJS(r.date_HK?.value, serverDateFormat).isSame(targetDate?.add(1, 'month'), 'month'))) {
                setDisplayMonth(targetDate?.add(1, 'month'));
                return
            }
        }

        setDisplayMonth(targetDate);
    }

    const handleTabOnClick = (url?: string, buttonName?: string, waRaceNo?: string) => {
        if (url && waRaceNo) {
            const meetingRaceNo = waRaceNo?.split("-")?.slice(1, 3) || [];
            let buttonName = "";
            switch (true) {
                case meetingRaceNo[0] == "NA" && meetingRaceNo[1] == "NA":
                    buttonName = "All";
                    break;
                case meetingRaceNo[1] == "NA":
                    buttonName = `${meetingRaceNo[0]}-All`;
                    break;
                default:
                    buttonName = meetingRaceNo.join("-");
                    break;
            }

            console.log("wp meetingrace", meetingRaceNo, buttonName)
            const curRace = myContextState.selectedMeeting?.RaceMeetingProfile?.races?.find((r: any) => r.no == myContextState?.selectedRaceNo.valueOf());
            adobeData(lang.langType === LANGTYPE_EN ? "en" : "zh-hk", "interaction", {
                pageId: "racing/simulcast",
                eventId: "racing/simulcast_Click_AnyPage_FormGuideShortcut",
                country: myContextState.selectedMeeting?.countryNameEn || '',
                buttonName: `racing/simulcast_Click_${buttonName}`,
                raceNo: generateAdobeDataRaceNo(myContextState.selectedMeetingDate, myContextState.selectedMeeting?.meetingVenueCode, myContextState.selectedRaceNo.valueOf()),
            });
        }
        setIsShowSelect(false);
    }

    const fetchFixtureData = useMemo(() => async (businessDate: Dayjs) => {
        getFixtureList(lang.langCode, true)
        .then((res: any) => {
            let newList = res?.data?.fixtureList?.filter((f: IFixture) => dayJS(f.date_HK?.value, serverDateFormat).isSameOrAfter(dayJS(window.globalConfig?.OTHERS?.CUTOFF_DATE, "YYYYMMDD")));
            newList = newList?.map((f: IFixture) => {
                // add raceDatetime from meeting level to fixture list by meeting mapping field
                const additData = getAdditionalInfoForFixture(lang.langCode, f, "_Calendar");
                const newObj = {
                  ...f,
                  ...additData,
                };

                return newObj
            });

            setInitialMonthDisplay(newList, businessDate);
            setFixtureData({
                fixtureList: newList,
                fixtureConfig: res?.config
            })
        })
        .catch((e: any) => {
            console.log(e);
        });
    }, []);

    useEffect(() => {
        getBusinessDate()
            .then((res: any) => {
                const bizdate: string = res?.timeOffset?.ts?.substring(0, res?.timeOffset?.ts?.indexOf('+'));
                setBusinessDate(dayJS(bizdate, "YYYY-MM-DD"));
                fetchFixtureData(dayJS(bizdate, "YYYY-MM-DD"));
            })
            .catch((e: any) => {
                console.log(e);
            });
    }, [])

    const checkFormGuidesData = () => {
        let show = false;
        for (let i = 0; i < myContextState?.formGuides?.length; i++) {
            const item = myContextState?.formGuides[i];
            if (item?.hasPdf) {
                show = true;
                break
            }
            const hasSubPdf = item?.nextLevel?.some((subItem) => subItem?.hasPdf)
            if (hasSubPdf) {
                show = true;
                break
            }
        }
        return show
    }
    const checkIfAllRacePdfEmpty = () => {
        return myContextState?.formGuides?.find((item:any) => !item?.nextLevel && item?.hasPdf)
    }
    const checkIfChildAllRacePdfEmpty = (itemData:any) => {
        return itemData?.nextLevel && itemData?.nextLevel?.[0] && itemData?.nextLevel?.[0]?.hasPdf;
    }
    const renderFormGuideList = (type: any) => {
        return <div className={`formGuideListNew ${checkIfAllRacePdfEmpty() ? 'firstRowforAllRace' : ''} ${type === 'mobile' ? 'mobile': 'pc'}`}
            style={type === 'mobile' ? { 
                display: isShowSelect ? 'block' : 'none',
                width: "calc(100% - 24px)",
                margin: "0 12px",
            }: 
            {
                width: '204px',
                marginRight: "14px",
            }}>
            {
                myContextState.formGuides?.map((item: FormGuideData, idx: number) => {
                    const hasSubPdf = item.nextLevel?.some((subItem) => subItem.hasPdf)
                    return (item.hasPdf || hasSubPdf) && (
                        <li key={idx}>
                            {
                                item.hasPdf ? (
                                    <div>
                                        <a className='fullWidth' href={item.url} target='_blank' data-bool={item.hasPdf} onClick={(e) => handleTabOnClick(item.url, item.name, item.waRaceNo)}>{item.name}</a>
                                    </div>
                                ) : (
                                    <div className='subtitlestyle'>{item.name}</div>
                                )
                            }
                            {hasSubPdf &&
                                <ul className={`formGuideSelectorNew ${checkIfChildAllRacePdfEmpty(item) ? 'firstChildRowforAllRace':''}`} key={`${item.name}_races`}>
                                    {item.nextLevel?.map((subItem: FormGuideData, subIdx: number) =>
                                        subItem.hasPdf && <a id={`${item.name}_${subItem.name}`} href={subItem.url} target='_blank' data-bool={subItem.hasPdf} key={subIdx} onClick={(e) => handleTabOnClick(subItem.url, subItem.name, subItem.waRaceNo)}>{subItem.name} </a>)}
                                </ul>
                            }
                        </li>
                    )
                })
            }
        </div>
    }

    return (
        <>
            {!isMobile ? 
            <Grid className="raceHeaderContainer">
                <section id="raceHeaderTitle" className="raceHeaderTitle">{t("racing_info_title")}</section>
                    <section className={"raceHeaderContent" + (!showCalendar ? " isCollapsed" : "")}>
                    <Grid container spacing={0} className={"meetingName"}>
                        <Grid item sx={{display: 'flex', alignItems: 'center', justifyContent:"space-between", width: "100%" }}>
                            <Grid className="meetingNameContainer" sx={{ ...textSize(17), justifyContent: "flex-start" }}>
                                <img src={`${myContextState.assetPrefix}/calendarFull.svg`} />
                                <span id="raceHeaderMeetingTitle">{formattedDate(toDate(props?.meetings?.[0]?.meetingDate?.value, dateFormat.cms.datetime), dateFormat.display.date)} - {getMeetingCountryAbbr(myContextState?.selectedMeeting?.meetingCountry || "", t)}</span>
                            </Grid>
                            <div className={`arrowDown${showCalendar ? " inverted" : ""}`} onClick={() => setCalender(!showCalendar)} style={{marginRight: "12px"}}></div>
                            {/* <Grid sx={{padding: '4px 12px', paddingLeft: '24px'}}>
                                <NextDayRaceBtn langCode={lang.langCode} nextDayRace={myContextState.nextDayRace} text={t("nextdayrace_btn")} />
                            </Grid> */}
                        </Grid>
                        {/* <Grid item className={`formGuideTitlePC_container ${isDim ? 'formGuide_PC_dim': ''}`} px={1} style={{ marginLeft: "auto" }} >
                            <div className="formGuideTitlePC" ><HorseFormGuideIcon dim={isDim}/><span>{t("formGuide")}</span><ExpandMoreIcon /></div>
                            {renderFormGuideList('')}
                        </Grid> */}
                        {
                            showCalendar ? <Grid item lg={12} sx={{ borderTop: "1px solid #B4B4B4", margin: "0 10px" }}>
                                <RacingCalendar isMobile={false} isSummary isCalendarShown={true} fixtureList={fixtureData?.fixtureList} config={fixtureData?.fixtureConfig} controlledMonth={displayMonth} businessDate={businessDate} isCurMonthEmpty={isCurrentMonthFin}/>
                            </Grid> : null
                        }
                    </Grid>
                </section>
            </Grid>
            :
            // Mobile
            <Grid className="raceHeaderContainer mobile">
                <section id="raceHeaderTitle" className="raceHeaderTitle mobile">{t("racing_info_title")}</section>
                <section className="raceHeaderContent mobile">
                    <Grid container spacing={0} className="meetingName">
                        <Grid item container lg={6}>
                            <Grid className={"meetingNameContainer mobile" + (!showCalendar ? " isCollapsed" : "")} sx={{ ...textSize(17) }} onClick={() => setCalender(!showCalendar)}>
                                <img src={`${myContextState.assetPrefix}/calendarFull.svg`} />
                                <span id="raceHeaderMeetingTitle">{formattedDate(toDate(props?.meetings?.[0]?.meetingDate?.value, dateFormat.cms.datetime), dateFormat.display.date)} - {getMeetingCountryAbbr(myContextState?.selectedMeeting?.meetingCountry || "", t)}</span>
                                <div className={`arrowDown${showCalendar ? " inverted" : ""} --mobile`}></div>
                            </Grid>
                            {/* <Grid sx={{margin: "4px auto 12px auto"}}>
                                <NextDayRaceBtn langCode={lang.langCode} isMobile={isMobile} nextDayRace={myContextState.nextDayRace} text={t("nextdayrace_btn")} />
                            </Grid> */}
                            {
                                showCalendar ? <Grid sx={{ display: { lg: 'none' }, width: "100%" }}>
                                    <RacingCalendar isMobile={true} isSummary isCalendarShown={true} fixtureList={fixtureData?.fixtureList} config={fixtureData?.fixtureConfig} controlledMonth={displayMonth} businessDate={businessDate}  isCurMonthEmpty={isCurrentMonthFin}/>
                                </Grid> : null
                            }
                        </Grid>
                        {/* <Grid sx={{ flexGrow: 1, borderRadius: "0 0 4px 4px" }} className={`${isDim ? 'formGuide_mobile_dim': ''}`}>
                            <div id="formGuideItem" className="formGuideList mobile" onClick={(e) => !isDim ? handleShowTab(e) : null}>
                                <div className="formGuideTitle">
                                    <HorseFormGuideIcon dim={isDim}/>
                                    <span>{t("formGuide")}</span>
                                </div>
                                <div className={`arrowDown${isShowSelect ? " inverted" : ""}`}></div>
                                {renderFormGuideList('mobile')}
                            </div>
                        </Grid> */}
                    </Grid>
                </section>
            </Grid >
            }
        </>
    )
}

export default RacingHeader;